import UseAxios from '../../../Api/http/http';
import { TECH_SESSION_PAGE } from '../../../Constants/strings';
import { getPerformancePeriodDetails } from '../../../Api/request/performance';
import moment from 'moment';

// date formatting utility
const formatDate = (dateString) => {
  return moment(dateString).format('D MMM, YYYY');
};

// fetch current performance cycle details
export const fetchCurrentPerformanceCycle = async (snackbarOpen) => {
  try {
    const response = await UseAxios(getPerformancePeriodDetails());
    const currentDate = moment().format('YYYY-MM-DD');

    const currentPeriod = response?.data?.performancePeriodDetails?.find(
      (performance) => {
        const startDate = moment(performance.startDate).format('YYYY-MM-DD');
        const endDate = moment(performance.endDate).format('YYYY-MM-DD');
        return currentDate >= startDate && currentDate <= endDate;
      },
    );

    return currentPeriod
      ? {
        id: currentPeriod.id,
        name: currentPeriod.cycleName,
        startDate: formatDate(currentPeriod.startDate),
        endDate: formatDate(currentPeriod.endDate),
      }
      : null;
  } catch (error) {
    snackbarOpen(TECH_SESSION_PAGE.OOPS_TRY_AGAIN, 'warning');
    return null;
  }
};
